export default "__VITE_ASSET__CwG$BRNK__"